import { type FragmentOf, readFragment } from "@opensea/graphql"
import { SITE_URL } from "@opensea/utils"
import type { CalendarOptions } from "datebook"
import { useTranslations } from "next-intl"
import { getCollectionOverviewUrl } from "@/components/collection/utils"
import { useCreateCalendarEventFragment } from "./use-create-calendar-event.fragment"

type UseCreateCalendarEventProps = {
  collectionName?: string
  collectionSlug?: string
}

export function useCreateCalendarEvent({
  collectionName,
  collectionSlug,
}: UseCreateCalendarEventProps) {
  const t = useTranslations("useCreateCalendarEvent")
  return (stageKey: FragmentOf<typeof useCreateCalendarEventFragment>) => {
    const stage = readFragment(useCreateCalendarEventFragment, stageKey)
    return {
      title: t("title", {
        collectionName: collectionName ?? "OpenSea drop",
        stageLabel: stage.label || t("publicStage"),
      }),
      description: t("description", {
        url: `${SITE_URL.href}${getCollectionOverviewUrl(collectionSlug ?? "")}`,
      }),
      start: new Date(stage.startTime),
      end: new Date(stage.endTime),
    } as CalendarOptions
  }
}
